import { render, staticRenderFns } from "./dev-actions-attr.vue?vue&type=template&id=592af3cf"
import script from "./dev-actions-attr.vue?vue&type=script&lang=js"
export * from "./dev-actions-attr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports